// File containing all function and variables required to provide the 
// subscription functionality across the Shop

// -----------------------------------------------------------------------------
// Global Variables

var subscriptions = {
  3: {
    "monthly": 39891992576179
    , "prepaid": 39891992608947
    , "recharge_selling_plan_id": 5628723466 // old 4383146250
    , "text": {
      "abo-prepaid": "Prepaid Abo"
      , "preis-prepaid": "500 €"
      , "li-1-prepaid": "20 € günstiger als das Monats-Abo"
      , "li-2-prepaid": "Einmalige Zahlung und fertig"
      , "li-3-prepaid": "Erhalte jede Spielbox zum richtigen Zeitpunkt"
      , "abo": "Monatlich kündbares Abo"
      , "preis-abo": "79 € pro Box"
      , "li-1-abo": "Standardpreis"
      , "li-2-abo": "Automatische Abbuchung pro Spielbox (alle 3 Monate)"
      , "li-3-abo": "Jederzeit kündbar & flexibel"
    }
  }
  , 6: {
    "monthly": 39891993657523
    , "prepaid": 39891993690291
    , "recharge_selling_plan_id": 5628985610 // old 4383179018
    , "text": {
      "abo-prepaid": "Prepaid Abo"
      , "preis-prepaid": "415 €"
      , "li-1-prepaid": "20 € günstiger als das Monats-Abo"
      , "li-2-prepaid": "Einmalige Zahlung und fertig"
      , "li-3-prepaid": "Erhalte jede Spielbox zum richtigen Zeitpunkt"
      , "abo": "Monatlich kündbares Abo"
      , "preis-abo": "79 € pro Box"
      , "li-1-abo": "Standardpreis"
      , "li-2-abo": "Automatische Abbuchung pro Spielbox (alle 3 Monate)"
      , "li-3-abo": "Jederzeit kündbar & flexibel"
    }
  }
  , 9: {
    "monthly": 39891994116275
    , "prepaid": 39891994149043
    , "recharge_selling_plan_id": 5628854538 // old 4382818570
    , "text": {
      "abo-prepaid": "Prepaid Abo"
      , "preis-prepaid": "330 €"
      , "li-1-prepaid": "15 € günstiger als das Monats-Abo"
      , "li-2-prepaid": "Einmalige Zahlung und fertig"
      , "li-3-prepaid": "Erhalte jede Spielbox zum richtigen Zeitpunkt"
      , "abo": "Monatlich kündbares Abo"
      , "preis-abo": "79 € pro Box"
      , "li-1-abo": "Standardpreis"
      , "li-2-abo": "Automatische Abbuchung pro Spielbox (alle 3 Monate)"
      , "li-3-abo": "Jederzeit kündbar & flexibel"
    }
  }
  , 12: {
    "monthly": 39891995361459
    , "prepaid": 39891995394227
    , "recharge_selling_plan_id": 5628920074 // old 4383211786
    , "text": {
      "abo-prepaid": "Prepaid Abo"
      , "preis-prepaid": "250 €"
      , "li-1-prepaid": "10 € günstiger als das Monats-Abo"
      , "li-2-prepaid": "Einmalige Zahlung und fertig"
      , "li-3-prepaid": "Erhalte jede Spielbox zum richtigen Zeitpunkt"
      , "abo": "Monatlich kündbares Abo"
      , "preis-abo": "79 € pro Box"
      , "li-1-abo": "Standardpreis"
      , "li-2-abo": "Automatische Abbuchung pro Spielbox (alle 3 Monate)"
      , "li-3-abo": "Jederzeit kündbar & flexibel"
    }
  }
  , 15: {
    "monthly": 39891994280115
    , "prepaid": 39891994312883
    , "recharge_selling_plan_id": 5628952842 // old 4383277322
    , "text": {
      "abo-prepaid": "Prepaid Abo"
      , "preis-prepaid": "165 €"
      , "li-1-prepaid": "10 € günstiger als das Monats-Abo"
      , "li-2-prepaid": "Einmalige Zahlung und fertig"
      , "li-3-prepaid": "Erhalte jede Spielbox zum richtigen Zeitpunkt"
      , "abo": "Monatlich kündbares Abo"
      , "preis-abo": "79 € pro Box"
      , "li-1-abo": "Standardpreis"
      , "li-2-abo": "Automatische Abbuchung pro Spielbox (alle 3 Monate)"
      , "li-3-abo": "Jederzeit kündbar & flexibel"
    }
  }
};

var subscriptions_rent = {
  3: {
    "monthly": 43866824737034
    , "prepaid": 43866824769802
    , "recharge_selling_plan_id": 5628723466 // old 4383146250
    , "deposit": 44748353405194
    , "deposit_rc_selling_plan_id": 5628690698 // old 4383310090
    , "text": {
      "abo-prepaid": "Prepaid Abo (Miete)"
      , "preis-prepaid": "273 €"
      , "deposit-prepaid": "Zzgl. 210 € Kaution (35 € pro Box)"
      , "li-1-prepaid": "15 € günstiger als das Monats-Abo"
      , "li-2-prepaid": "Alle Spielboxen zum richtigen Zeitpunkt"
      , "li-3-prepaid": "Spielen, lernen, lachen, wachsen und dabei die Umwelt schützen!"
      , "abo": "Monatlich kündbares Abo  (Miete)"
      , "preis-abo": "16 € pro Monat"
      , "deposit-monthly": "Zzgl. 35 € Kaution pro Box (alle 3 Monate)"
      , "li-1-abo": "Zzgl. 4,99 € Versand (alle 3 Monate)"
      , "li-2-abo": "Automatische Abbuchung pro Spielbox (alle 3 Monate) jederzeit flexibel kündbar"
      , "li-3-abo": "Spielen, lernen, lachen, wachsen und dabei die Umwelt schützen!"
    }
  }
  , 6: {
    "monthly": 43866824900874
    , "prepaid": 43866824999178
    , "recharge_selling_plan_id": 5628985610 // old 4383179018
    , "deposit": 44748353405194
    , "deposit_rc_selling_plan_id": 5628690698
    , "text": {
      "abo-prepaid": "Prepaid Abo (Miete)"
      , "preis-prepaid": "230 €"
      , "deposit-prepaid": "Zzgl. 175 € Kaution (35 € pro Box)"
      , "li-1-prepaid": "10 € günstiger als das Monats-Abo"
      , "li-2-prepaid": "Alle Spielboxen zum richtigen Zeitpunkt"
      , "li-3-prepaid": "Spielen, lernen, lachen, wachsen und dabei die Umwelt schützen!"
      , "abo": "Monatlich kündbares Abo  (Miete)"
      , "preis-abo": "16 € pro Monat"
      , "deposit-monthly": "Zzgl. 35 € Kaution pro Box (alle 3 Monate)"
      , "li-1-abo": "Zzgl. 4,99 € Versand (alle 3 Monate)"
      , "li-2-abo": "Automatische Abbuchung pro Spielbox (alle 3 Monate) jederzeit flexibel kündbar"
      , "li-3-abo": "Spielen, lernen, lachen, wachsen und dabei die Umwelt schützen!"
    }
  }
  , 9: {
    "monthly": 43866825687306
    , "prepaid": 43866825752842
    , "recharge_selling_plan_id": 5628854538 // old 4382818570
    , "deposit": 44748353405194
    , "deposit_rc_selling_plan_id": 5628690698
    , "text": {
      "abo-prepaid": "Prepaid Abo (Miete)"
      , "preis-prepaid": "182 €"
      , "deposit-prepaid": "Zzgl. 140 € Kaution (35 € pro Box)"
      , "li-1-prepaid": "10 € günstiger als das Monats-Abo"
      , "li-2-prepaid": "Alle Spielboxen zum richtigen Zeitpunkt"
      , "li-3-prepaid": "Spielen, lernen, lachen, wachsen und dabei die Umwelt schützen!"
      , "abo": "Monatlich kündbares Abo  (Miete)"
      , "preis-abo": "16 € pro Monat"
      , "deposit-monthly": "Zzgl. 35 € Kaution pro Box (alle 3 Monate)"
      , "li-1-abo": "Zzgl. 4,99 € Versand (alle 3 Monate)"
      , "li-2-abo": "Automatische Abbuchung pro Spielbox (alle 3 Monate) jederzeit flexibel kündbar"
      , "li-3-abo": "Spielen, lernen, lachen, wachsen und dabei die Umwelt schützen!"
    }
  }
  , 12: {
    "monthly": 43866826146058
    , "prepaid": 43866826211594
    , "recharge_selling_plan_id": 5628920074 // old 4383211786
    , "deposit": 44748353405194
    , "deposit_rc_selling_plan_id": 5628690698
    , "text": {
      "abo-prepaid": "Prepaid Abo (Miete)"
      , "preis-prepaid": "139 €"
      , "deposit-prepaid": "Zzgl. 105 € Kaution (35 € pro Box)"
      , "li-1-prepaid": "5 € günstiger als das Monats-Abo"
      , "li-2-prepaid": "Alle Spielboxen zum richtigen Zeitpunkt"
      , "li-3-prepaid": "Spielen, lernen, lachen, wachsen und dabei die Umwelt schützen!"
      , "abo": "Monatlich kündbares Abo  (Miete)"
      , "preis-abo": "16 € pro Monat"
      , "deposit-monthly": "Zzgl. 35 € Kaution pro Box (alle 3 Monate)"
      , "li-1-abo": "Zzgl. 4,99 € Versand (alle 3 Monate)"
      , "li-2-abo": "Automatische Abbuchung pro Spielbox (alle 3 Monate) jederzeit flexibel kündbar"
      , "li-3-abo": "Spielen, lernen, lachen, wachsen und dabei die Umwelt schützen!"
    }
  }
  , 15: {
    "monthly": 43866825883914
    , "prepaid": 43866825949450
    , "recharge_selling_plan_id": 5628952842 // old 4383277322
    , "deposit": 44748353405194
    , "deposit_rc_selling_plan_id": 5628690698
    , "text": {
      "abo-prepaid": "Prepaid Abo (Miete)"
      , "preis-prepaid": "91 €"
      , "deposit-prepaid": "Zzgl. 70 € Kaution (35 € pro Box)"
      , "li-1-prepaid": "5 € günstiger als das Monats-Abo"
      , "li-2-prepaid": "Alle Spielboxen zum richtigen Zeitpunkt"
      , "li-3-prepaid": "Spielen, lernen, lachen, wachsen und dabei die Umwelt schützen!"
      , "abo": "Monatlich kündbares Abo  (Miete)"
      , "preis-abo": "16 € pro Monat"
      , "deposit-monthly": "Zzgl. 35 € Kaution pro Box (alle 3 Monate)"
      , "li-1-abo": "Zzgl. 4,99 € Versand (alle 3 Monate)"
      , "li-2-abo": "Automatische Abbuchung pro Spielbox (alle 3 Monate) jederzeit flexibel kündbar"
      , "li-3-abo": "Spielen, lernen, lachen, wachsen und dabei die Umwelt schützen!"
    }
  }
};

// -----------------------------------------------------------------------------
// Functions

function calculate_delivery_age(delivery_month) {

  var MONTH_DAY_MULTIPLIER = 30.417
  var DELIVERY_BUFFER_DAYS = 3
  var PLAY_BUFFER_DAYS = 15

  return (delivery_month * MONTH_DAY_MULTIPLIER) - (DELIVERY_BUFFER_DAYS + PLAY_BUFFER_DAYS)
};


function calculate_delivery_date(delivery_month) {

  var birth_date = moment(sessionStorage.getItem('birthdate'), "DD/MM/YYYY");
  var today_date = moment();

  console.log(delivery_month, birth_date, today_date);

  var age_days = today_date.diff(birth_date, 'days')

  console.log("age_days", age_days);

  MONTH_DAY_MULTIPLIER = 30.417
  DELIVERY_BUFFER_DAYS = 10
  var delivery_age_days = (delivery_month * MONTH_DAY_MULTIPLIER) - DELIVERY_BUFFER_DAYS

  console.log("delivery_age_days", delivery_age_days);

  return "Versand am " + today_date.add(delivery_age_days - age_days, 'days').format('DD/MM/YYYY')

};

// -------------------------------------------------------------------------------------------------------
// index.liquid
function processNameDateForm() {

  var boxes = {
    3: "6645087568051"
    , 6: "6645092778163"
    , 9: "6645094613171"
    , 12: "6645097955507"
    , 15: "6645146976435"
    , 18: "6645150023859"
  };

  var bd = document.forms["babyform"]["birthdate"].value
  var babyname = document.forms["babyform"]["babyname"].value

  console.log(bd, babyname);

  if (bd == "") {
    // $( "#w-node-_29e7a4cf-880f-7d66-48da-d6d6c492d17f-41b90fcf" ).append( '<div class="w-form-fail"><div>Oops! Da ist etwas schiefgegangen. Bitte trage sowohl den Namen als auch das (erwartete) Geburtsdatum deines Babys ein, damit wir Dir die passenden Spielboxen raussuchen können.</div></div>' );
    document.getElementById('error-datepicker').style.display = "inline";
    return
  }

  else {
    document.getElementById("error-datepicker").remove();

    console.log(bd);
    console.log(babyname);

    sessionStorage.setItem("babyname", babyname);
    sessionStorage.setItem("birthdate", bd);

    birthdate_date = moment(bd, "DD/MM/YYYY");
    today = moment();

    var babyAgeDays = today.diff(birthdate_date, 'days')

    console.log(babyAgeDays);
    console.log(boxes);

    var scrollBoxKey = null
    var scrollAgeDiff = 99999

    for (var key in boxes) { 
      if (babyAgeDays <= calculate_delivery_age(parseInt(key))) {
        if (calculate_delivery_age(key) - babyAgeDays < scrollAgeDiff) {
          var scrollBoxKey = parseInt(key)
          var scrollAgeDiff = calculate_delivery_age(parseInt(key)) - babyAgeDays
        }
      }
    };

    console.log(scrollBoxKey);
    console.log(boxes[scrollBoxKey]);

    sessionStorage.setItem("subscription_key", parseInt(scrollBoxKey));

    for (var key in boxes) { 
      if (parseInt(key) < scrollBoxKey) {
        $("#" + boxes[key]).attr('class', "box-item is--inactive");
      }
      else {
        $("#" + boxes[key]).attr('class', "box-item"); 
      }
    };

    $('html, body').animate({
          scrollTop: $("#" + boxes[scrollBoxKey]).offset().top - $('#shopify-section-header').height() - 15    // Use element id to get element's location.
      }, 1000);

  }

};

// index.liquid
async function forwardAboPage() {

  var birthdate = sessionStorage.getItem("birthdate");
  var subscription_key = sessionStorage.getItem("subscription_key");

  await clearCart();

  if (birthdate == null) {
    window.location.href = '/pages/abo-info';
  }
  else if (subscription_key == 18) {
    window.location.href = 'products/klein-ganz-gross-spielbox';
  }
  else {
    window.location.href = '/pages/abo-liste';
  }
}


// page.abo-listed.liquid
function loadSubscriptionOverview() {
  var subscription_key = sessionStorage.getItem("subscription_key");
  var delivery_today = "Versand heute";

  var boxes = {
    3: {
      "name": "/products/schau-mal-spielbox"
      , "text": {
        "month_descriptor": "Monat 1-3"
        , "delivery_descriptor": (subscription_key == 3) ? delivery_today : calculate_delivery_date(0)
      }
    }
    , 6: {
      "name": "/products/lach-babbel-spielbox"
      , "text": {
        "month_descriptor": "Monat 4-6"
        , "delivery_descriptor": (subscription_key == 6) ? delivery_today : calculate_delivery_date(4)
      }
    }
    , 9: {
      "name": "/products/fuhlen-spielbox"
      , "text": {
        "month_descriptor": "Monat 7-9"
        , "delivery_descriptor": (subscription_key == 9) ? delivery_today : calculate_delivery_date(7)
      }
    }
    , 12: {
      "name": "/products/wunder-spielbox"
      , "text": {
        "month_descriptor": "Monat 10-12"
        , "delivery_descriptor": (subscription_key == 12) ? delivery_today : calculate_delivery_date(10)
      }
    }
    , 15: {
      "name": "/products/klein-ganz-gross-box"
      , "text": {
        "month_descriptor": "Monat 13-15"
        , "delivery_descriptor": (subscription_key == 15) ? delivery_today : calculate_delivery_date(13)
      }
    }
    , 18: {
      "name": "/products/nexus-box"
      , "text": {
        "month_descriptor": "Monat 16-18"
        , "delivery_descriptor": (subscription_key == 18) ? delivery_today : calculate_delivery_date(16)
      }
    }
  };

  for (var key in boxes) {

    $('div[name="' + boxes[parseInt(key)]['name'] + '"]').find('div[name="month_descriptor"]').text(boxes[parseInt(key)]['text']['month_descriptor'])

    console.log($('div[name="' + boxes[parseInt(key)]['name'] + '"]'));
    console.log(boxes[parseInt(key)]['text']['month_descriptor']);

    if (parseInt(key) < parseInt(subscription_key)) {
      // deactivate the card and don't show the delivery date
      $('div[name="' + boxes[parseInt(key)]['name'] + '"]').find('div[name="delivery_descriptor"]').text("Nicht im Abo")
      $('div[name="' + boxes[parseInt(key)]['name'] + '"]').attr('class', "checkout-box is--inactive");
      $('div[name="' + boxes[parseInt(key)]['name'] + '"]').find("img").attr('class', "check-icon is--inactive");
    }
    else {
      $('div[name="' + boxes[parseInt(key)]['name'] + '"]').find('div[name="delivery_descriptor"]').text(boxes[parseInt(key)]['text']['delivery_descriptor'])
      $('div[name="' + boxes[parseInt(key)]['name'] + '"]').attr('class', "checkout-box is--active");
      $('div[name="' + boxes[parseInt(key)]['name'] + '"]').find("img").attr('class', "check-icon is--active");
    }
  }
};


//page.abo-info.liquid
function processNameDateFormAboInfo() {

  var boxes = {
    3: "/products/schau-mal-spielbox"
    , 6: "/products/lach-babbel-spielbox"
    , 9: "/products/fuhlen-spielbox"
    , 12: "/products/wunder-spielbox"
    , 15: "/products/klein-ganz-gross-box"
    , 18: "/products/nexus-box"
  };

  var bd = document.forms["babyform"]["birthdate"].value
  var babyname = document.forms["babyform"]["babyname"].value

  if (bd == "") {
    // $( "#w-node-_29e7a4cf-880f-7d66-48da-d6d6c492d17f-41b90fcf" ).append( '<div class="w-form-fail"><div>Oops! Da ist etwas schiefgegangen. Bitte trage sowohl den Namen als auch das (erwartete) Geburtsdatum deines Babys ein, damit wir Dir die passenden Spielboxen raussuchen können.</div></div>' );
    $('#error-message').css("display","inline");
    return
  }

  else {

    $('#error-message').css("display","none");

    console.log(bd);
    console.log(babyname);

    sessionStorage.setItem("babyname", babyname);
    sessionStorage.setItem("birthdate", bd);

    birthdate_date = moment(bd, "DD/MM/YYYY");
    today = moment();

    var babyAgeDays = today.diff(birthdate_date, 'days')

    console.log(babyAgeDays);
    console.log(boxes);

    var boxKey = null
    var ageDiff = 99999

    for (var key in boxes) { 
      if (babyAgeDays <= calculate_delivery_age(parseInt(key))) {
        if (calculate_delivery_age(key) - babyAgeDays < ageDiff) {
          var boxKey = parseInt(key)
          var ageDiff = calculate_delivery_age(parseInt(key)) - babyAgeDays
        }
      }
    };

    sessionStorage.setItem("subscription_key", parseInt(boxKey));

    if (/miete/.test(window.location.href)) {
      window.location.href = '/pages/abo-liste-miete';  
    }
    else {
      window.location.href = '/pages/abo-liste';
    }
    
  }

};


//page.abo-checkbox.liquid

// Update Page content on load
async function loadCheckboxContent() {

  var babyname = sessionStorage.getItem("babyname");
  var birthdate = sessionStorage.getItem("birthdate");
  var agbcheck = parseInt(sessionStorage.getItem("agbcheck"));

  await clearCart();

  //jQuery.ajax({
  //  type: "POST",
  //  url: '/cart/clear.js',
  //  dataType: 'json'
  //});

  if (birthdate == null) {
    if (/miete/.test(window.location.href)) {
        window.location.href = '/pages/abo-liste-miete';  
      }
      else {
        window.location.href = '/pages/abo-liste';
      }
  }

  birthdate_date = moment(birthdate, "DD/MM/YYYY");
  today = moment();

  // Find the right subscription
  var babyAgeDays = today.diff(birthdate_date, 'days')
  var subscription_key = null;
  var current_min_age_diff = 99999;

  for (var key in subscriptions) { 
    if (babyAgeDays <= calculate_delivery_age(key)) {
      if (calculate_delivery_age(key) - babyAgeDays < current_min_age_diff) {
        console.log(key);
        var subscription_key = key
        var current_min_age_diff = calculate_delivery_age(key) - babyAgeDays
      }
    }
  };

  console.log(subscription_key);

  sessionStorage.setItem("subscription_key", subscription_key);

  if (/miete/.test(window.location.href)) {
    for (t in subscriptions_rent[subscription_key]['text']) {
      console.log(t);
      $("#" + t).text(subscriptions_rent[subscription_key]['text'][t])
    };
  }
  else {
    for (t in subscriptions[subscription_key]['text']) {
      console.log(t);
      $("#" + t).text(subscriptions[subscription_key]['text'][t])
    };
  }
  
  $('#checkbox-prepaid').prop("checked", false);
  $('#checkbox-prepaid').prev().attr('class', "w-checkbox-input w-checkbox-input--inputType-custom checkbox")

  $('#checkbox-abo').prop("checked", false);
  $('#checkbox-abo').prev().attr('class', "w-checkbox-input w-checkbox-input--inputType-custom checkbox")

  if (agbcheck == 1) {
    document.getElementById('agb-data-protection-checkbox').checked = true;  
  }

};

// Uncheck other Checkbox on Click
function checkUncheck(check_id, uncheck_id) {
  var subscription_key = sessionStorage.getItem("subscription_key");
  console.log(check_id, uncheck_id);
  $(check_id).prop("checked", true);
  $(uncheck_id).prop("checked", false);
  $(uncheck_id).prev().attr('class', "w-checkbox-input w-checkbox-input--inputType-custom checkbox")
  console.log(subscriptions[subscription_key]);
};

// Process Selection State and forward to Shopify Checkout Page
async function forwardCheckoutRent() {

  await clearCart();

  var key = sessionStorage.getItem('subscription_key');
  // var birthdate = sessionStorage.getItem('birthdate');
  // var babyname = sessionStorage.getItem("babyname");

  var properties = {_birth_date: sessionStorage.getItem('birthdate'), _baby_name: sessionStorage.getItem("babyname")}

  await addItem(subscriptions_rent[key]['deposit'], 1, subscriptions_rent[key]['deposit_rc_selling_plan_id'], properties);
  await addItem(subscriptions_rent[key]['monthly'], 1, subscriptions_rent[key]['recharge_selling_plan_id'], properties);

  window.location.href = '/checkout';
}


async function forwardCheckout() {

  if (document.getElementById('agb-data-protection-checkbox').checked != true) {
    sessionStorage.setItem('agbcheck', 0);
    $('#agb-data-protection-checkbox-fail').css("display","inline");
    return
  }
  else {
    $('#agb-data-protection-checkbox-fail').css("display","none");
  }

  var key = sessionStorage.getItem('subscription_key');
  // var birthdate = sessionStorage.getItem('birthdate');
  // var babyname = sessionStorage.getItem("babyname");

  var properties = {_birth_date: sessionStorage.getItem('birthdate'), _baby_name: sessionStorage.getItem("babyname")}

  // Find out which subscription is active
  if (document.getElementById("checkbox-prepaid").checked === true) {
    if (/miete/.test(window.location.href)) {
      await addItem(subscriptions_rent[key]['deposit'], 1, undefined, {});
      await addItem(subscriptions_rent[key]['prepaid'], 1, undefined, properties);
    }
    else {
      await addItem(subscriptions[key]['prepaid'], 1, undefined, properties);
    }
    $('#error-message').css("display","none");
  }

  else if (document.getElementById("checkbox-abo").checked === true) {
    if (/miete/.test(window.location.href)) {
      await addItem(subscriptions_rent[key]['deposit'], 1, subscriptions_rent[key]['deposit_rc_selling_plan_id'], properties);
      await addItem(subscriptions_rent[key]['monthly'], 1, subscriptions_rent[key]['recharge_selling_plan_id'], properties);
    }
    else {
      await addItem(subscriptions[key]['monthly'], 1, subscriptions[key]['recharge_selling_plan_id'], properties);
    }
    $('#error-message').css("display","none");
  }

  else {
    $('#error-message').css("display","inline");
    $('html, body').animate({scrollTop: 0}, 1000);
    return
  }

  //document.getElementsByName("xsell-checkbox").forEach(function (item) {
  //  if (item.checked == true) {
  //    order['items'].push({"id": item.id, "quantity": 1})
  //  }
  // });

  window.location.href = '/checkout';
}

// ---------------------------------------------------------------------------------------------------------------------
// cart.liquid

function setAGBCheck(id) {
  console.log(id);
  console.log(document.getElementById(id).checked);
  if (document.getElementById(id).checked == true) {
    sessionStorage.setItem('agbcheck', 1);
  }
  else {
    sessionStorage.setItem('agbcheck', 0);
  }

  console.log(sessionStorage.getItem('agbcheck'));

};


async function forwardCartToCheckout(id) {
  var el = document.getElementById('cart-header-checkbox-fail');
  if (document.getElementById(id).checked == true) {
    sessionStorage.setItem('agbcheck', 1);
    if (el != null) {el.style.display = "none";}

    // Before forwarding to checkout, verify that the cart contains 1 deposit per rent subscription.
    const currentCart = await getCart();
    console.log(currentCart);

    // Condense Cart Content to only VariantIds and Quantities
    var cartItems = {};
    for (let i = 0; i < currentCart.items.length; i++) {
      cartItems[currentCart.items[i]['variant_id']] = currentCart.items[i]['quantity'];
    }

    // For each item in the cart, check which subscription it belongs to, to find the right deposit VariantId
    for (var variantId in cartItems) {
      for (var key in subscriptions_rent) {
        if (subscriptions_rent[key]['prepaid'] == variantId || subscriptions_rent[key]['monthly'] == variantId) {
          // Add Deposit VariantId to real Cart, if it is not contained in current cart at all.
          if (!(subscriptions_rent[key]['deposit'] in cartItems)) {
            await addItem(subscriptions_rent[key]['deposit'], cartItems[variantId], undefined, {})
          }
          // Now if the actual Deposit VariantId is actually in the cart, check that it is at the right quantity.
          // Update the cart line item quantity if not.
          else if (cartItems[subscriptions_rent[key]['deposit']] != cartItems[variantId]) {
            await updateItem({
              id: subscriptions_rent[key]['deposit'],
              quantity: cartItems[variantId],
              properties: {}
            })
          }
        }
      }
    }

    window.location.href = '/checkout';
  }
  else {
    sessionStorage.setItem('agbcheck', 0);
    if (el != null) {el.style.display = "inline"};
  }
}

// ---------------------------------------------------------------------------------------------------------------------
// https://nozzlegear.com/shopify/using-javascript-to-manage-a-shopify-cart

async function getCart() {
    const result = await fetch("/cart.json");

    if (result.status === 200) {
        return result.json();
    }

    throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
};

// Example
// const cart = await getCart();

async function addSubscription(variantId, quantity, sellingPlanId, properties = {}) {
    const result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: variantId,
            quantity: quantity,
            selling_plan: sellingPlanId,
            properties: properties
        })
    })
};

// Example
// const lineItem = await addSubscription(123456, 1, { foo: "bar" });
// await addSubscription(39891992576179, 1, 4383146250, {_birth_date: "2022-01-01", _baby_name: "Finn"})
// console.log(lineItem.properties); // { foo: "bar" }

async function addItem(variantId, quantity, sellingPlanId, properties = {}) {
    if(sellingPlanId === undefined) {
        const result = await fetch("/cart/add.json", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
              id: variantId,
              quantity: quantity,
              properties: properties
          })
        })
    }

    else {
      const result = await fetch("/cart/add.json", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          },
          body: JSON.stringify({
              id: variantId,
              quantity: quantity,
              selling_plan: sellingPlanId,
              properties: properties
          })
        })
    }
}

// Data needs to be a dict object containing all relevant data including properties to ensure they remain.
// id: VariantId, quantity, properties, selling_plan: SellingPlanId
async function updateItem(data) {
    const result = await fetch("/cart/change.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(data)
    });
}

// Example
// const lineItem = await addItem(123456, 1);

async function clearCart() {
    const result = await fetch("/cart/clear.json", {
        method: "POST",
        headers: {
            "Accept": "application/json"
        }
    })
};
